import { PopupModal } from './components';

export const Modals = {
  PopupModal,
};
